<template lang='pug'>
  div(:class="{dark: $vuetify.theme.dark, light: !$vuetify.theme.dark}")
    slot(name='empty', v-if='!value.length')
      v-container(fill-height)
        v-row(align='center' justify='center')
          .text-h5.grey--text {{noItems}}
    SlickList#sortable-list.list(:value='value' :helper-class="dragClass" use-drag-handle @input='update')
      SlickItem.list-item(v-for='(item, index) in value' :index='index' :key='index' :class='{disabled: item.disabled}')
        v-icon(v-handle) reorder
        | &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        slot(name='row' :item='item' :index='index')
</template>

<script>
import {SlickList, SlickItem, HandleDirective} from 'vue-slicksort';

export default {
  name: 'SortableList',
  components: {
    SlickItem,
    SlickList
  },
  directives: {handle: HandleDirective},
  props: {
    itemKey: {
      type: String,
      default: 'guid'
    },
    noItems: {
      type: String,
      default: 'No Items'
    },
    value: {
      default() {
        return [];
      }
    }
  },
  computed: {
    dragClass() {
      if (this.$vuetify.theme.dark) return 'item-drag-dark';
      return 'item-drag';
    }
  },
  methods: {
    scrollToBottom() {
      const container = this.$el.querySelector('#sortable-list');
      container.scrollTop = container.scrollHeight;
    },
    update(list) {
      this.$emit('input', list);
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang='scss' scoped>
.list {
  max-height: 70vh;
  overflow: auto;
  border-radius: 4px;
}

.light .list {
  background-color: #f3f3f3;
  border: 1px solid #efefef;
}

.dark .list {
  background-color: #222222;
  border: 1px solid #333333;
}

.dark .list-item {
  color: #FFFFFF;
  background-color: #222222;
  border-bottom: 1px solid #333333;
}

.dark .disabled {
  background-color: #444444;
}

.list-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-weight: 400;
}

.light .list-item {
  color: #333;
  background-color: #fff;
  border-bottom: 1px solid #efefef;
}

.light .disabled {
  background-color: #E0E0E0;
}

.light .list-item:hover {
  background-color: #EEEEEE;
}

.item-drag {
  z-index: 250;
  font-family: 'Roboto', sans-serif;
  box-shadow: 0 10px 20px rgba(0, 0, 0, .2);
  cursor: row-resize;
  border: 1px solid #fff;
  background-color: #fff;
}
.item-drag-dark {
  z-index: 250;
  font-family: 'Roboto', sans-serif;
  box-shadow: 0 10px 20px rgba(0, 0, 0, .2);
  cursor: row-resize;
  border: 1px solid #EEEEEE;
  background-color: #333333;
  color: #FFFFFF;
}
</style>
